import React, { useEffect, useState } from 'react';
import { ContractorDashboard } from './components/roles/contractor/ContractorDashboard';
import { Sidebar } from './components/layout/Sidebar';
import { JobLocationsPage } from './components/locations/JobLocationsPage';
import { LoginPage } from './components/auth/LoginPage';
import { useAuth } from './components/auth/AuthContext';
import { ForemanDashboard } from './components/roles/foreman/ForemanDashboard';
import { ManageForemenPage } from './components/roles/contractor/ManageForemenPage';
import { ManageBrokersPage } from './components/roles/contractor/ManageBrokersPage';
import { ManageTruckingCompaniesPage } from './components/roles/broker/ManageTruckingCompaniesPage';
import { BrokerDashboard } from './components/roles/broker/BrokerDashboard';
import { TruckingCompanyDashboard } from './components/roles/trucking/TruckingCompanyDashboard';
import { DriverDashboard } from './components/roles/driver/DriverDashboard';
import { MenuIcon } from 'lucide-react';
import { MessageProvider } from './components/messaging/MessageContext';
import { JobMessagingProvider } from './components/messaging/JobMessagingContext';
import { FactoringDashboard } from './components/roles/factoring/FactoringDashboard';
export function App() {
  const {
    isAuthenticated,
    user,
    logout
  } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [activeRole, setActiveRole] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Set active role when user logs in
  useEffect(() => {
    if (user) {
      setActiveRole(user.role);
    }
  }, [user]);
  if (!isAuthenticated) {
    return <LoginPage data-id="element-0" />;
  }
  // Determine which role view to show
  const displayRole = user?.isAdmin ? activeRole : user?.role;
  return <MessageProvider data-id="element-1">
      <JobMessagingProvider data-id="element-2">
        <div className="flex min-h-screen bg-gray-50" data-id="element-3">
          {/* Sidebar Toggle Button - Visible on all screen sizes */}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="fixed top-4 left-4 z-30 bg-[#0F2A52] text-white p-2 rounded-md shadow-lg" aria-label="Toggle sidebar" data-id="element-4">
            <MenuIcon size={24} data-id="element-5" />
          </button>
          <Sidebar currentRole={displayRole || ''} setCurrentRole={setActiveRole} onLogout={logout} isAdmin={user?.isAdmin} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} data-id="element-6" />
          <div className={`flex-1 transition-all duration-300 ${sidebarOpen ? 'lg:ml-64' : 'ml-0'} overflow-auto`} data-id="element-7">
            {displayRole === 'contractor' && currentPage === 'dashboard' && <ContractorDashboard onNavigate={setCurrentPage} data-id="element-8" />}
            {displayRole === 'contractor' && currentPage === 'job-locations' && <JobLocationsPage onBack={() => setCurrentPage('dashboard')} data-id="element-9" />}
            {displayRole === 'contractor' && currentPage === 'manage-foremen' && <ManageForemenPage onBack={() => setCurrentPage('dashboard')} data-id="element-10" />}
            {displayRole === 'contractor' && currentPage === 'manage-brokers' && <ManageBrokersPage onBack={() => setCurrentPage('dashboard')} data-id="element-11" />}
            {displayRole === 'broker' && currentPage === 'dashboard' && <BrokerDashboard onNavigate={setCurrentPage} data-id="element-12" />}
            {displayRole === 'broker' && currentPage === 'manage-trucking' && <ManageTruckingCompaniesPage onBack={() => setCurrentPage('dashboard')} data-id="element-13" />}
            {displayRole === 'broker' && currentPage !== 'dashboard' && currentPage !== 'manage-trucking' && <div className="p-4 lg:p-6 pt-16 lg:pt-6" data-id="element-14">
                  <h1 className="text-xl lg:text-2xl font-bold mb-4" data-id="element-15">
                    Broker Dashboard
                  </h1>
                  <p className="mb-4" data-id="element-16">Welcome to the broker dashboard.</p>
                  <div className="bg-white p-4 lg:p-6 rounded-lg shadow" data-id="element-17">
                    <p data-id="element-18">Broker Dashboard Feature: {currentPage} (Coming Soon)</p>
                  </div>
                </div>}
            {displayRole === 'foreman' && <ForemanDashboard data-id="element-19" />}
            {displayRole === 'trucking' && <TruckingCompanyDashboard onNavigate={setCurrentPage} data-id="element-20" />}
            {displayRole === 'driver' && <DriverDashboard data-id="element-21" />}
            {displayRole === 'factoring' && <FactoringDashboard data-id="element-22" />}
            {displayRole === 'admin' && <div className="p-4 lg:p-6 pt-16 lg:pt-6" data-id="element-23">
                <h1 className="text-xl lg:text-2xl font-bold mb-4" data-id="element-24">
                  Admin Dashboard
                </h1>
                <p className="mb-4" data-id="element-25">
                  Welcome to the admin dashboard. From here you can manage all
                  aspects of the system.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-26">
                  <div className="bg-white p-4 rounded shadow" data-id="element-27">
                    <h2 className="font-bold mb-2" data-id="element-28">User Management</h2>
                    <p className="text-gray-600" data-id="element-29">
                      Manage users, roles and permissions
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded shadow" data-id="element-30">
                    <h2 className="font-bold mb-2" data-id="element-31">System Settings</h2>
                    <p className="text-gray-600" data-id="element-32">
                      Configure global application settings
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded shadow" data-id="element-33">
                    <h2 className="font-bold mb-2" data-id="element-34">Activity Logs</h2>
                    <p className="text-gray-600" data-id="element-35">
                      View system and user activity
                    </p>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </JobMessagingProvider>
    </MessageProvider>;
}